import {
  ConsolidatedTransactionDetails,
  ConsolidatedTransactionDetailsResponseDTO,
} from '../../entities/ConsolidatedTransaction';

const ConsolidatedTransactionDetailsResponseDTOtoConsolidatedTransactionDetailsAdapter = (
  response: ConsolidatedTransactionDetailsResponseDTO,
): ConsolidatedTransactionDetails => {
  if (!response.body) {
    throw Error();
  }

  const {
    creationDate,
    valueDate,
    orderId,
    status,
    type,
    details,
    amount,
    lastMovementDate,
    hasDocuments,
    globalOrderId,
    transactionId,
    mandateId,
    fromAccount,
    toAccount,
    accountCurrency,
    exchangeCurrency,
    exchangeRate,
    charges,
    country,
    beneficiaryAddress,
    beneficiaryFullName,
    bankName,
    bankBic,
    sortCode,
    cor,
    bicBankCode,
    inn,
    kpp,
    vo,
    bop,
    hasRateRequest,
    dealRefNo,
    dealUsrCode,
    specialRate,
    trxRateGiven,
    alias,
    accountProductDescription,
    voDescription,
    customerId,
    fromAccountIban,
    totalCharges,
    trxCollectedAmount,
    trxCommissionAmount,
    trxExpensesAmount,
    trxOmniId,
    trxSettlementAmount,
    fromCurrencyId,
    toCurrencyId,
    beneficiaryCountry,
    beneficiaryCity,
    exchangeRateApproximate,
    metadata,
    orderProcessType,
    processedStatus,
    processingStatus,
    rateCurrencyISO,
    internalDestinationCurrencyId,
    internalDestinationCurrencyShortDescr,
    cancellationReason,
    p2pType,
    p2pValue,
    lastModifyCustomerId,
  } = response.body;

  return new ConsolidatedTransactionDetails(
    creationDate,
    valueDate,
    orderId,
    status,
    type,
    details,
    amount,
    lastMovementDate,
    hasDocuments,
    globalOrderId,
    transactionId,
    mandateId,
    fromAccount,
    toAccount,
    accountCurrency,
    exchangeCurrency,
    exchangeRate,
    charges,
    country,
    beneficiaryCountry,
    beneficiaryCity,
    beneficiaryAddress,
    beneficiaryFullName,
    bankName,
    bankBic,
    sortCode,
    cor,
    bicBankCode,
    inn,
    kpp,
    vo,
    bop,
    hasRateRequest,
    dealRefNo,
    dealUsrCode,
    specialRate,
    trxRateGiven,
    alias,
    accountProductDescription,
    voDescription,
    customerId,
    fromAccountIban,
    totalCharges,
    trxCollectedAmount,
    trxCommissionAmount,
    trxExpensesAmount,
    trxOmniId,
    trxSettlementAmount,
    fromCurrencyId,
    toCurrencyId,
    exchangeRateApproximate,
    metadata,
    orderProcessType,
    processedStatus,
    processingStatus,
    rateCurrencyISO,
    internalDestinationCurrencyId,
    internalDestinationCurrencyShortDescr,
    cancellationReason,
    p2pType,
    p2pValue,
    lastModifyCustomerId,
  );
};

export { ConsolidatedTransactionDetailsResponseDTOtoConsolidatedTransactionDetailsAdapter };
